import { useEffect, useState } from "react";

/**
 * Returns true only after `active` has stayed true continuously for `delayMs`.
 * Resets to false the instant `active` goes false. This is how we make
 * fast/cached loads (the common case) show NOTHING — a loader only appears
 * if the wait is genuinely long enough to be worth showing.
 */
export function useDelayedFlag(active: boolean, delayMs = 300): boolean {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!active) {
      setShown(false);
      return;
    }
    const t = setTimeout(() => setShown(true), delayMs);
    return () => clearTimeout(t);
  }, [active, delayMs]);
  return shown;
}
